<template>
  <div>
    <header-bar>レポート</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">確定レポート</h3>
        <router-link
          :to="{name: 'faq-detail', params: {id: isBtoC?60:81}}"
          target="_blank"
          class="c-text-link">
          確定レポートについて
        </router-link>
      </div>
      <div class="page-block__inner">
        <div class="report-area">
          <div class="report-area__text report-area__text--distribution">
            月末に確定する配信ストアの金額、
            <br class="sp">販売数をご確認いただけます。
          </div>
        </div>
        <div class="report-block__heading report-block-adjustment">
          <h3
            v-if="totals.title"
            class="report-block__title">
            {{ totals.title }} ({{ totals.month }})
          </h3>
        </div>
        <div class="report-block profit">
          <div class="report-profit-area">
            <div class="report-profit-area__column">
              <div class="report-profit-area__wrap">
                <table class="report-profit-area__table">
                  <thead class="report-profit-area__thead">
                    <tr>
                      <th colspan="2">ディストリビューション</th>
                      <th
                        v-if="showCopyrightReport"
                        rowspan="2">
                        著作権収益
                      </th>
                      <th
                        class="report-profit-area-total__th"
                        rowspan="2">
                        収益合計(税込)
                      </th>
                    </tr>
                    <tr>
                      <th>ストリーミング</th>
                      <th>ダウンロード</th>
                    </tr>
                    <tr></tr>
                  </thead>
                  <tbody
                    v-if="totals.payable_money > 0 || totals.payable_money_copr > 0"
                    class="report-profit-area__tbody">
                    <tr>
                      <td>
                        {{ (totals.quantity_st || 0) | number }}
                        <span style="font-size: 13px; color: gray;">回</span>
                      </td>
                      <td>
                        {{ (totals.quantity_dl || 0) | number }}
                        <span style="font-size: 13px; color: gray;">回</span>
                      </td>
                      <td
                        v-if="showCopyrightReport"
                        rowspan="2">
                        <decimal-styled-number :number="totals.payable_money_copr" />
                      </td>
                      <td
                        class="report-profit-area-total__td"
                        rowspan="2">
                        ¥{{ paymentTotals(totals) | roundNumber }}
                        <div style="font-size:16px">
                          (うち消費税: ¥{{ paymentTax(totals) | roundNumber }})
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <decimal-styled-number :number="totals.payable_money_st" />
                      </td>
                      <td>
                        <decimal-styled-number :number="totals.payable_money_dl" />
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-else
                    class="report-rank-song-area__tbody">
                    <tr>
                      <td
                        class="no-data"
                        colspan="10">
                        データはありません。
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  v-if="!!company.enable_payment_request"
                  class="c-btn-wrap c-btn-wrap--with-pager">
                  <router-link
                    :to="{ name : 'balance' }"
                    class="c-btn c-btn--narrow c-btn--right pcmt10">
                    支払い申請
                    <span class="c-btn__icon-arrow"></span>
                  </router-link>
                </div>
                <div
                  v-if="isBtoB"
                  class="c-btn-wrap c-btn-wrap--with-pager">
                  <router-link
                    :to="{ name : 'balance' }"
                    class="c-btn c-btn--narrow c-btn--right pcmt10">
                    支払い履歴一覧
                    <span class="c-btn__icon-arrow"></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="'finalized_reports' in totals && totals.finalized_reports.length && isBtoB"
          class="report-block download">
          <p>{{ totals.title }}分の分配報告書です。下記よりダウンロードください。</p>
          <finalized-report-download-buttons
            :payment_id="totals.payment_id"
            :reports="totals.finalized_reports" />
        </div>
        <div
          v-if="'other_finalized_reports' in totals
            && totals.other_finalized_reports.length
            && isBtoB"
          class="report-block download">
          <p>{{ totals.other_title }}分の分配報告書です。下記よりダウンロードください。</p>
          <finalized-report-download-buttons
            :payment_id="totals.other_payment_id"
            :reports="totals.other_finalized_reports" />
        </div>
        <copyright-report-section
          v-if="isBtoB
            && 'copyright_reports' in totals
            && totals.copyright_reports && totals.copyright_reports.length > 0
            && showCopyrightReport"
          :copyright-reports="totals.copyright_reports"/>
        <div
          v-if="isBtoB"
          class="report-block">
          過去の分配報告書、レポートCSVはこちらからご確認いただけます。
          <div
            class="report-finalized-download-buttons-area">
            <router-link
              :to="{ name : 'report-finalized-list'}"
              class="c-btn
                report-finalized-download-buttons-area__c-btn--narrow
                report-finalized-download-buttons-area__download-btn"
              href="#">
              報告書ダウンロード
            </router-link>
          </div>
        </div>

        <div class="report-block distribution">
          <div class="report-block__heading">
            <h3 class="report-block__title">{{ currentMonth }}分</h3>
            <div class="case-date-group">
              <div class="case-date-label">
                <label
                  class="control-label">
                </label>
              </div>
              <div class="case-date-item">
                <div class="c-select_wrap">
                  <select
                    v-model="targetMonth"
                    class="c-select">
                    <option
                      v-for="(month, index) in months"
                      :key="index"
                      :value="month.value">
                      {{ month.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="report-distribution__heading">
            <p class="report-distribution__title">ディストリビューション</p>
            <ul class="report-distribution__tab">
              <li
                class="report-distribution__tab-item"
                :class="{ current: reportMode === 'track' }">
                <a
                  href="#"
                  @click.prevent="changeMode('track')">
                  楽曲レポート
                </a>
              </li>
              <li
                class="report-distribution__tab-item"
                :class="{ current: reportMode === 'store' }">
                <a
                  href="#"
                  @click.prevent="changeMode('store')">
                  ストアレポート
                </a>
              </li>
              <li
                v-if="showCopyrightReport"
                class="report-distribution__tab-item"
                :class="{ current: reportMode === 'copyright' }">
                <a
                  href="#"
                  @click.prevent="changeMode('copyright')">
                  著作権レポート
                </a>
              </li>
            </ul>
            <div
              v-show="reportMode === 'track'"
              class="report-distribution__checkbox-area">
              <div class="checkbox">
                <label>
                  <input
                    type="radio"
                    :checked="reportType === 'all'"
                    @change="checkType('all')">
                  <div class="option-input"></div> すべて
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    type="radio"
                    :checked="reportType === 'release'"
                    @change="checkType('release')">
                  <div class="option-input"></div> リリース
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    type="radio"
                    :checked="reportType === 'artist'"
                    @change="checkType('artist')">
                  <div class="option-input"></div> アーティスト
                </label>
              </div>
            </div>
          </div>
          <div
            v-if="reportMode !== 'copyright'"
            class="report-distribution-area">
            <div style="text-align: right;font-size: 0.8em">
              ※販売収益は税抜金額となります。
            </div>
            <div class="report-distribution-area__column">
              <div class="c-table-caption">横にスクロールしてご覧ください</div>
              <div class="report-distribution-area__wrap">
                <table class="report-distribution-area__table">
                  <thead class="report-distribution-area__thead">
                    <tr>
                      <th class="u-text-align-left">楽曲名</th>
                      <th>アルバム</th>
                      <th>単曲</th>
                      <th>
                        ストリーミング
                        <div v-if="reportMode === 'store'">マネタイズ</div>
                      </th>
                      <th>販売収益</th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="reportMode === 'track'"
                    class="report-distribution-area__tbody">
                    <tr
                      v-if="reports.total.payable_money > 0"
                      class="report-distribution-area__total">
                      <td class="u-text-align-left">合計</td>
                      <td class="number-cell">
                        {{ reports.total.quantity_dl_album || 0 | number }}
                      </td>
                      <td class="number-cell">{{ reports.total.quantity_dl || 0 | number }}</td>
                      <td class="number-cell">{{ reports.total.quantity_st || 0 | number }}</td>
                      <td class="number-cell">
                        <decimal-styled-number
                          :number="reports.total.payable_money"
                          upper-font-size="1.4rem" />
                      </td>
                    </tr>
                    <tr v-else>
                      <td
                        class="no-data"
                        colspan="5">
                        データはありません。
                      </td>
                    </tr>
                    <template
                      v-for="(artist, key) in reports.artists">
                      <tr
                        :key="`artist_${key}`"
                        class="report-distribution-area__artist">
                        <td class="u-text-align-left">{{ artist.name }}</td>
                        <td class="number-cell">{{ artist.quantity_dl_album || 0 | number }}</td>
                        <td class="number-cell">{{ artist.quantity_dl || 0 | number }}</td>
                        <td class="number-cell">{{ artist.quantity_st || 0 | number }}</td>
                        <td class="number-cell">
                          <decimal-styled-number
                            :number="artist.payable_money"
                            upper-font-size="1.4rem" />
                        </td>
                      </tr>
                    </template>
                    <template
                      v-for="(album, artistId) in reports.albums">
                      <tr
                        v-if="reportType === 'all'"
                        :key="`artist_${artistId}`"
                        class="report-distribution-area__artist">
                        <td class="u-text-align-left">{{ album.name }}</td>
                        <td class="number-cell">{{ album.quantity_dl_album || 0 | number }}</td>
                        <td class="number-cell">{{ album.quantity_dl || 0 | number }}</td>
                        <td class="number-cell">{{ album.quantity_st || 0 | number }}</td>
                        <td class="number-cell">
                          <decimal-styled-number
                            :number="album.payable_money"
                            upper-font-size="1.4rem" />
                        </td>
                      </tr>
                      <template v-for="(item, index) in album.discs">
                        <tr
                          :key="`album_${index}`"
                          class="report-distribution-area__album">
                          <td class="u-text-align-left">{{ item.title }} (アルバム)</td>
                          <td class="number-cell">{{ item.quantity_dl_album || 0 | number }}</td>
                          <td class="number-cell">{{ item.quantity_dl || 0 | number }}</td>
                          <td class="number-cell">{{ item.quantity_st || 0 | number }}</td>
                          <td class="number-cell">
                            <decimal-styled-number
                              :number="item.payable_money"
                              upper-font-size="1.4rem" />
                          </td>
                        </tr>
                        <template v-if="reportType === 'all'">
                          <tr
                            v-for="(track, key3) in item.tracks"
                            :key="`track_${key3}`"
                            class="report-distribution-area__table">
                            <td class="u-text-align-left">{{ track.title }}</td>
                            <td class="number-cell">0</td>
                            <td class="number-cell">{{ track.quantity_dl || 0 | number }}</td>
                            <td class="number-cell">{{ track.quantity_st || 0 | number }}</td>
                            <td class="number-cell">
                              <decimal-styled-number
                                :number="track.payable_money"
                                upper-font-size="1.4rem" />
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                  </tbody>
                  <tbody
                    v-else
                    class="report-distribution-area__tbody">
                    <tr
                      v-if="reports.total.payable_money > 0"
                      class="report-distribution-area__total">
                      <td class="u-text-align-left">合計</td>
                      <td class="number-cell">
                        {{ reports.total.quantity_dl_album || 0 | number }}
                      </td>
                      <td class="number-cell">{{ reports.total.quantity_dl || 0 | number }}</td>
                      <td class="number-cell">{{ reports.total.quantity_st || 0 | number }}</td>
                      <td class="number-cell">
                        <decimal-styled-number
                          :number="reports.total.payable_money"
                          upper-font-size="1.4rem" />
                      </td>
                    </tr>
                    <tr v-else>
                      <td
                        class="no-data"
                        colspan="5">
                        データはありません。
                      </td>
                    </tr>
                    <tr
                      v-for="(store, key4) in reports.stores"
                      :key="`store_${key4}`"
                      class="report-distribution-area__table">
                      <td class="u-text-align-left">{{ store.name }}</td>
                      <td class="number-cell">{{ store.quantity_dl_album || 0 | number }}</td>
                      <td class="number-cell">{{ store.quantity_dl || 0 | number }}</td>
                      <td class="number-cell">{{ store.quantity_st || 0 | number }}</td>
                      <td class="number-cell">
                        <decimal-styled-number
                          :number="store.payable_money"
                          upper-font-size="1.4rem" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            v-if="reportMode === 'copyright' && showCopyrightReport"
            class="report-distribution-area">
            <div class="report-distribution-area__column">
              <div class="c-table-caption">横にスクロールしてご覧ください</div>
              <div class="report-distribution-area__wrap">
                <table class="report-distribution-area__table">
                  <thead class="report-distribution-area__thead">
                    <tr>
                      <th class="w-30">楽曲名</th>
                      <th class="w-30">使用者名</th>
                      <th>作品コード</th>
                      <th>使用数</th>
                      <th>支払額</th>
                    </tr>
                  </thead>
                  <tbody
                    class="report-distribution-area__tbody">
                    <template v-if="reports.copyrights && reports.copyrights.length >0">
                      <tr
                        v-for="(item) in reports.copyrights"
                        :key="item.id">
                        <td class="u-text-align-left">{{ item.report_content.track_title }}</td>
                        <td class="u-text-align-left">{{ item.report_content.service_name }}</td>
                        <td>{{ item.report_content.work_code }}</td>
                        <td class="number-cell">{{ item.report_content.quantity | number }}</td>
                        <td class="number-cell">
                          <decimal-styled-number
                            :number="item.payment_amount"
                            upper-font-size="1.4rem" />
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td
                          class="no-data"
                          colspan="6">
                          データはありません。
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'
import FinalizedReportDownloadButtons from './FinalizedReportDownloadButtons'
import DecimalStyledNumber from './DecimalStyledNumber'
import CopyrightReportSection from '../Copyright/Common/CopyrightReportSection'

export default {
  components: {
    CopyrightReportSection,
    DecimalStyledNumber,
    HeaderBar,
    FinalizedReportDownloadButtons,
  },
  filters: {
    roundNumber(value) {
      return value
        ? new Intl.NumberFormat('ja-JP').format(Math.round(value * 1000) / 1000)
        : 0
    },
  },
  data() {
    return {
      reportMode: 'track',
      reportType: 'all',
      targetMonth: '',
      months: [],
      reports: {
        total: {
          quantity_dl: 0,
          quantity_st: 0,
          quantity_copr: 0,
          payable_money: 0,
          payable_money_with_tax: 0,
          payable_money_tax: 0,
          payable_money_copr: 0,
          payable_money_copr_tax: 0,
        },
        artists: [],
        albums: [],
      },
      initialized: false,
      totals: {},
      company: [],
      permission: null,
      previewPaymentId: null,
    }
  },
  computed: {
    currentMonth() {
      return `${this.targetMonth.substr(0, 4)}年${this.targetMonth.substr(4, 2)}月`
    },
    showCopyrightReport() {
      if (this.isBtoC) {
        return true
      }
      // BtoB は管理ユーザも含めて非表示
      return false
    },
  },
  watch: {
    targetMonth() {
      this.fetchItems()
    },
    reportMode() {
      this.fetchItems()
    },
    reportType() {
      this.fetchItems()
    },
  },
  mounted() {
    this.previewPaymentId = this.$route.query.preview_payment_id
    this.fetchTotal()
    this.fetchMonths()
    this.fetchCompanies()
    this.targetMonth = this.$route.query.month || this.months[0].value
    this.reportMode = this.$route.query.mode || 'track'
    this.reportType = this.$route.query.type || 'all'
  },
  methods: {
    changeMode(mode) {
      this.reportMode = mode
    },
    checkType(type) {
      this.reportType = type
    },
    async fetchMonths() {
      const { data } = await window.axios.get('/api/client/reports/get-months')
      data.forEach(month => {
        if (month) {
          this.months.push({
            label: `${month.substr(0, 4)}年${month.substr(4, 2)}月`,
            value: month,
          })
        }
      })
      this.targetMonth = this.months[0].value
    },
    async fetchItems() {
      const { data } = await window.axios.get('/api/client/reports/finalized', {
        params: {
          month: this.targetMonth,
          type: this.reportType,
          mode: this.reportMode,
          preview_payment_id: this.previewPaymentId,
        },
      })
      this.reports = data
      this.$router.replace({
        name: 'report-finalized',
        query: {
          month: this.targetMonth,
          mode: this.reportMode,
          type: this.reportType,
          preview_payment_id: this.previewPaymentId,
        },
      }, () => {}, () => {})
    },
    async fetchTotal() {
      const { data } = await window.axios.get('/api/client/reports/latest-finalized', {
        params: {
          preview_payment_id: this.previewPaymentId,
        },
      })
      this.totals = data
    },
    async fetchCompanies() {
      const { data } = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      this.company = data.company
      this.permission = data.permission
    },
    paymentTotals(totals) {
      return this.showCopyrightReport
        ? (totals.payable_money_with_tax ?? 0) + (totals.payable_money_copr ?? 0)
        : (totals.payable_money_with_tax ?? 0)
    },
    paymentTax(totals) {
      return this.showCopyrightReport
        ? Math.floor((totals.payable_money_tax ?? 0) + (totals.payable_money_copr_tax ?? 0))
        : (totals.payable_money_tax ?? 0)
    },
  },
}

</script>

<style scoped>

@media screen and (min-width: 896px) {
  .c-btn--narrow {
    padding: 11px 101px;
  }
}

.number-cell {
  text-align: right;
}
.w-30{
  width: 30% !important;
}

</style>
